import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单字段
      form: {
        corpName: null, // 企业名称
        corpCode: null, // 社会信用代码
        economicNum: null,
        corpRole: null,
        agencyQualification: null
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "企业名称：",
          value: "corpName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "社会信用代码：",
          value: "corpCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "登记注册类型：",
          value: "economicNum",
          placeholder: "请输入",
          clearable: true,
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201507131651150072"
          }
        },
        {
          type: "select",
          label: "企业用户类型：",
          value: "corpRole",
          placeholder: "请输入",
          clearable: true,
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201610190956534719"
          }
        },
        {
          type: "slot",
          label: "招标代理资格：",
          slotName: "agencyQualification"
        }
      ],
      // 招标代理资格
      options: [
        {
          label: "有",
          value: "0"
        },
        {
          label: "无",
          value: "1"
        }
      ],
      // 表格按钮
      btnList: [
        {
          name: "完善资料",
          type: "success",
          icon: "el-icon-edit"
        }
      ],
      // 列表数据
      tableData: [],
      // 列表基础数据
      tableColumns: [
        {
          label: "企业名称",
          prop: "corpName",
          isShow: true,
          width: "280",
          fixed: true
        },
        {
          label: "状态",
          slotName: "state",
          width: "100",
          fixed: true
        },
        {
          label: "注册时间",
          prop: "insertDate",
          width: "180",
          fixed: true
        },
        {
          label: "社会信用代码",
          prop: "corpCode",
          width: "200"
        },
        {
          label: "企业登记注册类型",
          prop: "economicNumName",
          width: "150"
        },
        {
          label: "是否进行招标代理活动",
          prop: "agencyQualification",
          width: "200"
        },
        {
          label: "法定代表人姓名",
          prop: "legalMan",
          width: "150"
        },
        {
          label: "成立日期",
          prop: "corpBirthDate",
          width: "120"
        },
        {
          label: "企业网址",
          prop: "url",
          width: "150"
        },
        {
          label: "注册所在省（自治区、直辖市）",
          prop: "provinceNumName",
          width: "250"
        },
        {
          label: "注册所在地（市、州、盟）",
          prop: "cityNumName",
          width: "240"
        },
        {
          label: "注册所在县（区、市、旗）",
          prop: "countyNumName",
          width: "240"
        },
        {
          label: "住所",
          prop: "address",
          width: "250"
        },
        {
          label: "操作",
          slotName: "operation"
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      total: 0,
      // 用户类型
      loginType: sessionStorage.getItem("loginType"),
      // 用户类型
      userFlag: sessionStorage.getItem("userFlag"),
      // 用户标识
      yhbs: null,
      // 弹窗初始状态
      dialogVisible: false,
      // 企业名称
      corpName: null
    };
  },
  // 模板编译完成
  mounted() {
    // 用户标识
    if (this.userFlag != "注册用户") {
      // 隐藏表头按钮
      this.btnList = [];
    }
    if (this.userFlag == "工作人员") {
      this.btnList = [
        {
          name: "新增",
          type: "success",
          icon: "el-icon-edit"
        }
      ];
    }
    // 用户标识
    if (this.userFlag == "注册用户") {
      // 隐藏页面查询
      this.formSearchList = [];
    }
    // 执行获取列表数据方法
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开遮罩
      this.loading = true;
      // 发起请求
      fun_PostAction(
        "/corpBasicinfo/list",
        {
          ...this.form,
          ...this.reqPageData
        },
        0
      ).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭遮罩层
          this.loading = false;
        } else {
          // 关闭遮罩层
          this.loading = false;
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @param {e} 选中vlue的值
     * @param {value} 选中的类型
     * @author shuhua
     */
    fun_GetSelectVal(event, value) {
      // 企业登记注册类型
      if (value === "economicNum") {
        // 赋值
        this.form.economicNum = event;
      }
      // 企业用户类型
      if (value === "corpRole") {
        // 赋值
        this.form.corpRole = event;
      }
      // 招标代理资格
      if (value === "agencyQualification") {
        // 赋值
        this.form.agencyQualification = event;
      }
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_click(e) {
      switch (e) {
        case "完善资料":
          // 子传父
          this.$emit("fun_Details", "corpRegistrationDetails", {
            type: "edit",
            id: this.tableData[0].id
          });
          break;
        case "新增":
          // 打开弹窗
          this.dialogVisible = true;
          break;
      }
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * @description 进入详情
     * @author
     */
    fun_Details(e) {
      // 判断是否为工作人员
      if (sessionStorage.getItem("userFlag") === "工作人员") {
        // 跳转详情页面
        this.$router.push({
          path: "/corpRegistrationDetail",
          query: {
            type: "details",
            id: e.val.id
          }
        });
        return false;
      }
      // 子传父
      this.$emit("fun_Details", "corpRegistrationDetails", {
        id: e.val.id,
        type: "details"
      });
    },
    /**
     * 弹窗关闭
     */
    fun_Close() {
      // 清空
      this.corpName = null;
    },
    /**
     * @description 更新企业信息
     * @author
     */
    fun_Update(e) {
      // 企业名称
      this.corpName = e.corpName;
      // 同步数据
      this.fun_Sync();
    },
    /**
     * @description 同步企业信息
     * @author
     */
    fun_Sync() {
      // shifou
      if (!this.corpName) {
        //
        this.$message.error("请输入企业名称");
        return;
      }
      // 询问框
      this.$confirm("确定同步【" + this.corpName + "】企业信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 打开遮罩
        this.loading = true;
        // 发起请求
        fun_PostAction("/corpBasicinfo/synchronousUserInfo", {
          corpName: this.corpName
        }).then(res => {
          // 结构res.data
          const { result, msg } = res.data;
          // 请求成功
          if (result) {
            // 关闭弹窗
            this.dialogVisible = false;
            // 清空
            this.corpName = null;
            // 提示消息
            this.$message.success(msg);
          } else {
            // 提示请求失败的信息
            this.$message.error(msg);
          }
          // 关闭遮罩层
          this.loading = false;
        });
      });
    }
  }
};
